import styled from 'styled-components';
import { DynamicExteriorImagePreviewStyled } from '../DynamicExteriorImagePreviewStyled';
import { rem } from 'polished';

export const DynamicExteriorImagePreviewAP = styled(DynamicExteriorImagePreviewStyled)`
    
`;
